import { defineStore } from "pinia";
import { computed, ref } from "vue";
import lodashUniqBy from "lodash-es/uniqBy";
import { emailValidationRegExps } from "@helpers/EmailHelper";

// Types
import { CustomCollabCustomerTemplate } from "@contracts/customCollabs";
import { CustomerSavedCreatorsPayload, CustomerSavedCreatorSummary } from "@contracts/customerSavedCreators";

export const useNewCustomCollabWizardStore = defineStore("newCustomCollabWizard", () => {
  // Creators =================================================================
  const isLoadingCreators = ref<boolean>(true);
  const savedCreatorsPayload = ref<CustomerSavedCreatorsPayload | null>(null);
  const creatorsToDisplay = computed<Array<CustomerSavedCreatorSummary>>(() => {
    if (!savedCreatorsPayload.value) {
      return [];
    } else {
      return savedCreatorsPayload.value?.manuallySaved;
    }
  });
  const selectedCreatorId = ref<string>("");
  const selectedCreator = computed<CustomerSavedCreatorSummary | null>(() => {
    if (!selectedCreatorId.value) {
      return null;
    } else {
      return creatorsToDisplay.value.find(c => c.shrpaCreatorId === selectedCreatorId.value);
    }
  });
  const invitedCreatorEmail = ref<string>("");

  // Custom collab templates ==================================================
  const isLoadingTemplates = ref<boolean>(false);
  const customCollabTemplatesList = ref<Array<CustomCollabCustomerTemplate>>([]);
  const selectedTemplateId = ref<string>("");

  // Steps validation =========================================================
  // "Select creator step
  const isInvitedCreatorEmailValid = computed<boolean>(() => {
    return invitedCreatorEmail.value ? emailValidationRegExps.forgiving.test(invitedCreatorEmail.value) : false;
  });

  const isSelectCreatorFormValid = computed<boolean>(() => {
    return selectedCreatorId.value ? Boolean(selectedCreatorId.value) : isInvitedCreatorEmailValid.value;
  });

  // Initial message ==========================================================
  const initialMessage = ref<string>("");
  const isInitMessageIncludesTemplatePlaceholders = computed<boolean>(() => {
    if (!selectedTemplateId.value) {
      return false;
    }
    const selectedTemplate = customCollabTemplatesList.value.find(t => t.templateId === selectedTemplateId.value);
    const allPlaceholders: Array<string> = selectedTemplate.messageText.match(/\[[^\]]*]/gim);

    let isIncludesPlaceholders = false;
    allPlaceholders.forEach(p => {
      if (initialMessage.value.includes(p)) {
        isIncludesPlaceholders = true;
      }
    });

    return isIncludesPlaceholders;
  });

  return {
    // Creators
    isLoadingCreators,
    savedCreatorsPayload,
    creatorsToDisplay,
    selectedCreatorId,
    selectedCreator,
    invitedCreatorEmail,

    // Custom collab templates
    isLoadingTemplates,
    customCollabTemplatesList,
    selectedTemplateId,

    // Steps validation
    isInvitedCreatorEmailValid,
    isSelectCreatorFormValid,

    // Initial message
    initialMessage,
    isInitMessageIncludesTemplatePlaceholders,
  };
});
